import React, { useEffect } from "react";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');

.jbes {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 44vh;
  text-align: center;
  padding: clamp(32px, 5vw, 64px) clamp(16px, 5vw, 32px);
  font-family: 'Inter', sans-serif;
}

/* ── Icon ring ── */
.jbes-icon-wrap {
  position: relative;
  width: clamp(88px, 14vw, 128px);
  height: clamp(88px, 14vw, 128px);
  margin-bottom: clamp(20px, 3vw, 28px);
}

/* outer pulse ring */
.jbes-ring {
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  border: 1.5px solid rgba(201,162,39,0.35);
  animation: jbesPulse 2.8s ease-in-out infinite;
}
.jbes-ring-2 {
  position: absolute;
  inset: -18px;
  border-radius: 50%;
  border: 1px solid rgba(201,162,39,0.18);
  animation: jbesPulse 2.8s ease-in-out infinite 0.4s;
}
@keyframes jbesPulse {
  0%,100% { opacity: 1; transform: scale(1); }
  50%      { opacity: 0.4; transform: scale(1.04); }
}
@media (prefers-reduced-motion: reduce) {
  .jbes-ring, .jbes-ring-2 { animation: none; }
}

/* main circle */
.jbes-circle {
  width: 100%; height: 100%;
  border-radius: 50%;
  background: #FBF3E7;
  border: 2px solid rgba(201,162,39,0.35);
  display: flex; align-items: center; justify-content: center;
  position: relative;
}

/* Om symbol */
.jbes-om {
  font-size: clamp(38px, 6vw, 54px);
  color: #B8860B;
  font-family: serif;
  line-height: 1;
  opacity: 0.55;
  user-select: none;
}

/* Search magnifier badge */
.jbes-search-badge {
  position: absolute;
  bottom: -4px; right: -4px;
  width: clamp(28px, 4vw, 36px);
  height: clamp(28px, 4vw, 36px);
  border-radius: 50%;
  background: linear-gradient(135deg, #E3C77A, #B8860B);
  border: 2px solid #FFFCF7;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 2px 10px rgba(184,134,11,0.35);
}
.jbes-search-badge svg {
  width: clamp(13px, 2vw, 16px);
  height: clamp(13px, 2vw, 16px);
}

/* ── Text ── */
.jbes-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(17px, 2.2vw, 22px);
  font-weight: 700;
  color: #6E1228;
  margin-bottom: 8px;
  line-height: 1.3;
}
.jbes-title em { font-style: italic; color: #B8860B; }

.jbes-msg {
  font-size: clamp(12.5px, 1.3vw, 14px);
  color: #9C8B7A;
  line-height: 1.65;
  max-width: 300px;
}

/* ── Decorative lotus dots ── */
.jbes-dots {
  display: flex; align-items: center; gap: 8px;
  margin-top: clamp(18px, 2.5vw, 24px);
}
.jbes-dot {
  width: 5px; height: 5px; border-radius: 50%;
  background: rgba(201,162,39,0.35);
}
.jbes-dot.mid {
  width: 7px; height: 7px;
  background: rgba(201,162,39,0.6);
}
`;

/* ─── Search icon SVG ─────────────────────────────────────────────────────── */
const SearchIcon = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
      stroke="#4A2E10"
      strokeWidth="2.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

/* ─── Component ───────────────────────────────────────────────────────────── */
const EmptyStateCentered = ({ message = "No profiles found." }) => {
  useEffect(() => {
    const id = "jbes-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="jbes" role="status" aria-label={message}>
      {/* Icon */}
      <div className="jbes-icon-wrap" aria-hidden="true">
        <div className="jbes-ring-2" />
        <div className="jbes-ring" />
        <div className="jbes-circle">
          <span className="jbes-om">ꣽ</span>
          <div className="jbes-search-badge">
            <SearchIcon />
          </div>
        </div>
      </div>

      {/* Title */}
      <p className="jbes-title">
        No <em>Sacred</em> Matches Found
      </p>

      {/* Message */}
      <p className="jbes-msg">{message}</p>

      {/* Decorative dots */}
      <div className="jbes-dots" aria-hidden="true">
        <div className="jbes-dot" />
        <div className="jbes-dot mid" />
        <div className="jbes-dot" />
      </div>
    </div>
  );
};

export default EmptyStateCentered;
